import { ref, provide, inject, reactive } from 'vue'
import { useNuxtApp, useRouter } from '#imports'

// Create a global shared state object that can be accessed from anywhere
const isHistoryBack = ref(false)

export function useHistoryNavigation() {
  const router = useRouter()
  
  // Set up function to initialize the navigation tracking (call once in app.vue)
  const provideHistoryNavigation = () => {
    if (typeof window !== 'undefined') {
      // Listen to popstate for back/forward button clicks
      window.addEventListener('popstate', () => {
        isHistoryBack.value = true
      })
      
      // Reset the flag after each navigation
      router.afterEach(() => {
        setTimeout(() => {
          isHistoryBack.value = false
        }, 2000) // Increased timeout so components can read it during onMounted
      })
    }
    
    // Make it available for injection in other components
    provide('isHistoryBack', isHistoryBack)
    
    return { isHistoryBack }
  }
  
  // Function to use the history back state in components
  const useHistoryState = () => {
    // Try to inject, fallback to the global state
    const state = inject('isHistoryBack', isHistoryBack)
    return { 
      isBackNavigation: state.value,
      isHistoryBack: state
    }
  }
  
  return {
    isHistoryBack,
    provideHistoryNavigation,
    useHistoryState
  }
} 